export function loadAmbassadorWixEventsWebHttp() {
	return import('@wix/ambassador-wix-events-web-http/http' /* webpackChunkName: "wixEventsWeb" */)
}

export function loadAmbassadorEventsV2RsvpHttp(): Promise<typeof import('@wix/ambassador-events-v2-rsvp-http/http')> {
	return import('@wix/ambassador-events-v2-rsvp-http/http' /* webpackChunkName: "wixEventsRsvp" */)
}
